import {
  Visibility as VisibilityIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import {Button} from "@mui/material";
import { useNavigate } from "react-router-dom";


const VideosPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const token = localStorage.getItem("accessToken");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate()
  

  useEffect(() => {
    fetchVideos();
  }, []);

  const handleAddNewVideo = () =>{
    navigate("/addvideo")
  }

  const handleDeleteClick = async (id) => {
    try {
      if (!token) {
        console.error("Access token is missing");
        return;
      }

      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this video!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
      });

      if (result.isConfirmed) {
        const response = await fetch(
          `https://backend.placemyfilms.com/videosUpload/deleteById/${id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to delete video: ${response.statusText}`);
        }

        setData((prevData) => prevData.filter((video) => video.id !== id));

        await Swal.fire({
          title: "Deleted!",
          text: "Video has been deleted successfully.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error deleting video:", error);
      await Swal.fire({
        title: "Error!",
        text: "Failed to delete video. Please try again.",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
    }
  };

  const fetchVideos = async () => {
    try {
      setLoading(true);
      if (!token) {
        console.error("Access token is missing");
        return;
      }

      const response = await fetch(
        "https://backend.placemyfilms.com/videosUpload/getAll",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }

      const responseData = await response.json();

      if (responseData.status && Array.isArray(responseData.result)) {
        const mappedData = responseData.result.map((item) => ({
          id: item.id,
          filePath: item.filePath,
          packageType: item.packageType,
          userId: item.user_id,
          url: item.url,
          createdAt: new Date(item.createdAt).toLocaleString(),
          updatedAt: new Date(item.updatedAt).toLocaleString(),
        }));
        setData(mappedData);
      } else {
        console.error("Invalid response structure:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      await Swal.fire({
        title: "Error!",
        text: "Failed to fetch videos. Please try again.",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    { field: "filePath", headerName: "File Path", flex: 1.5 },
    {
      field: "packageType",
      headerName: "Package Type",
      flex: 1,
      renderCell: (params) => `$${params.value}`,
    },
    { field: "userId", headerName: "User ID", flex: 0.7 },
    { field: "createdAt", headerName: "Created At", flex: 1.2 },
    { field: "updatedAt", headerName: "Updated At", flex: 1.2 },
    {
      field: "preview",
      headerName: "View video",
      flex: 0.8,
      renderCell: (params) => (
        <a
          href={params.row.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <IconButton>
            <VisibilityIcon />
          </IconButton>
        </a>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.8,
      renderCell: (params) => (
        <Box>
          <Tooltip title="View Details">
            <Link to={`/video/viewvideo/${params.row.id}`}>
              <IconButton>
                <VisibilityIcon />
              </IconButton>
            </Link>
          </Tooltip>
          {/* <Tooltip title="Edit Video">
            <Link to={`/videos/edit/${params.row.id}`}>
              <IconButton>
                <EditIcon />
              </IconButton>
            </Link>
          </Tooltip> */}
          <Tooltip title="Delete">
            <IconButton onClick={() => handleDeleteClick(params.row.id)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header
        title="Video Records"
        subtitle="View all uploaded videos in the system"
      />
      {/* <Button
          variant="contained"
          // color="secondary"
          onClick={handleAddNewVideo}
          sx={{
            backgroundColor: colors.greenAccent[500],
            ":hover": {
              backgroundColor: colors.greenAccent[600],
            },
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          Add New Video
        </Button> */}
      <Box
        m="0 0 0 0"
        height="65vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
            fontSize: "14px",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[800],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .row-divider": {
            borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
          },
          "& .MuiDataGrid-overlay": {
            backgroundColor: "rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <DataGrid
          rows={data}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          pageSize={10}
          rowsPerPageOptions={[5, 10, 20]}
          getRowClassName={() => "row-divider"}
          loading={loading}
          disableSelectionOnClick
          initialState={{
            sorting: {
              sortModel: [{ field: "createdAt", sort: "desc" }],
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default VideosPage;
